/**
 * Utility functions for cryptographic operations
 */

import CryptoJS from 'crypto-js';

/**
 * Creates a SHA-256 hash of the input string
 * @param input The string to hash
 * @returns A hex-encoded hash string
 */
export const createSha256Hash = (input: string): string => {
    if (!input) {
        return '';
    }

    // Use crypto-js for synchronous SHA-256 hashing
    return CryptoJS.SHA256(input).toString(CryptoJS.enc.Hex);
};
